module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2s"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/tra#tra"
    }
  }, [_vm._v("Note on Transliteration")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/int#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("Informal Citizens: Palestinian Refugees in Syria")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("From Humanitarianism to Development: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNRWA")]), _vm._v(" and Palestinian Refugees")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("Ṣumūd and Sustainability: Reinterpreting Development in Palestinian Refugee Camps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("“Must We Live in Barracks to Convince People We Are Refugees?”: The Politics of Camp Improvement")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("“A Camp Is a Feeling Inside”: Urbanization and the Boundaries of Palestinian Refugee Identity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bey#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Beyond Suffering and Victimhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epi#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ref#ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0